import { $api } from '@/shared/api/axiosInstance';

export const register = async () => {
    const url = '/api/auth/register';

    const res = await $api.post(url);

    return res.request.responseURL;
};
